import React, { createContext, useContext, useState } from "react";
import { CircularProgress, Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

interface PDFUploadContextType {
  isUploading: boolean;
  startUpload: () => void;
  endUpload: () => void;
}

const PDFUploadContext = createContext<PDFUploadContextType | null>(null);

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  text: {
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export function PDFUploadProvider({ children }: { children: React.ReactNode }) {
  const [isUploading, setIsUploading] = useState(false);
  const classes = useStyles();

  const startUpload = () => setIsUploading(true);
  const endUpload = () => setIsUploading(false);

  return (
    <PDFUploadContext.Provider value={{ isUploading, startUpload, endUpload }}>
      {children}
      <Backdrop open={isUploading} className={classes.backdrop}>
        <CircularProgress color="inherit" size={60} />
        <div className={classes.text}>Uploading PDF...</div>
      </Backdrop>
    </PDFUploadContext.Provider>
  );
}

export function usePDFUpload() {
  const context = useContext(PDFUploadContext);
  if (!context) {
    throw new Error("usePDFUpload must be used within PDFUploadProvider");
  }
  return context;
}
